import { createContext, useContext, type Dispatch, type PropsWithChildren, type SetStateAction } from 'react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track } from 'modules/core/lib/Tracking'

let trackingSearch = ''

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>
  setTrakingSearch: Dispatch<string>
}

function setTrakingSearch(keyword: string) {
  trackingSearch = keyword
}

const CommandBarContext = createContext<Props | null>(null)

export const CommandBarContextProvider = ({
  setOpen,
  children,
}: PropsWithChildren<Omit<Props, 'setTrakingSearch'>>) => {
  const handleKeyDown = async (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k' && !event.altKey) {
      event.preventDefault()
      setOpen((previousState) => {
        !previousState
          ? track('Create search Start')
          : track('Create search Cancel', { search_keyword: trackingSearch })
        return !previousState
      })
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown)

    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <CommandBarContext.Provider value={{ setOpen, setTrakingSearch }}>
      {children}
    </CommandBarContext.Provider>
  )
}

export const useCommandBar = () => {
  const context = useContext(CommandBarContext)
  if (!context) throw 'useCommandBar must be used within a CommandBarContextProvider'
  return context
}
